import React from 'react';
import DOMPurify from 'dompurify';
import { v4 as uuidv4 } from 'uuid';
import styled from 'styled-components';

/**
 * ==================
 * @title 문장 라인 정렬
 * ==================
 **/
export const formatContentUtil = (content: string) => {
  return DOMPurify.sanitize(content.replace(/(\r\n|\n|\n|\r)/g, '<br />'));
};
/**
 * @title 문장 줄 바꿈 해주는 유틸 Hook
 *
 * @author 정휘학
 * @since 2024.03.18
 * */
export const underLine = (text: string) => {
  if (text) {
    const lines = text.split('\n');
    return lines.map((line, index) => (
      <React.Fragment key={uuidv4()}>
        {line}
        <br />
      </React.Fragment>
    ));
  }
  return null;
};

/**
 * @title URL 감지 및 링크 변환 + 줄바꿈 처리 함수 유틸 Hook
 *
 * @author 김남규
 * @since 2025.01.08
 * */
const LinkTagStyled = styled.a<{ themeType?: 'black' }>`
  color: ${(props) => (props.themeType === 'black' ? props.theme.colors.black : props.theme.colors.white)};
  text-decoration: underline;
  cursor: pointer;
`;

export const linkUnderLine = (text: string, themeType?: 'black') => {
  if (text) {
    // URL 감지 정규식
    const urlRegex = /(https?:\/\/[^\s]+|www\.[^\s]+|[a-zA-Z0-9-]+\.[a-zA-Z]{2,})/g;

    // 텍스트를 줄 단위로 분리
    const lines = text.split('\n');

    return lines.map((line) => (
      <React.Fragment key={uuidv4()}>
        {/* 각 줄에서 URL 변환 */}
        {line.split(urlRegex).map((part) => {
          if (urlRegex.test(part)) {
            // URL에 http:// 또는 https://가 없으면 자동으로 https:// 추가
            let formattedUrl = part;

            if (!formattedUrl.startsWith('http://') && !formattedUrl.startsWith('https://')) {
              // 'www.'로 시작하거나 도메인만 있으면 https:// 추가
              formattedUrl = formattedUrl.startsWith('www.')
                ? `https://${formattedUrl}`
                : `https://www.${formattedUrl}`;
            }

            // URL인 경우 <span-linkType> 태그로 변환
            return (
              // <AtagStyled
              //   key={uuidv4()}
              //   href={formattedUrl}
              //   target="_blank"
              //   rel="noopener noreferrer"
              //   themeType={themeType}
              // >
              //   {part}
              // </AtagStyled>
              <LinkTagStyled
                key={uuidv4()}
                href={formattedUrl}
                target="_blank"
                rel="noopener noreferrer"
                themeType={themeType}
              >
                {part}
              </LinkTagStyled>
            );
          }
          // URL이 아닌 경우 일반 텍스트로 출력
          return <React.Fragment key={uuidv4()}>{part}</React.Fragment>;
        })}
        <br />
      </React.Fragment>
    ));
  }
  return null;
};

/**
 * @title [Web발신] 문자 제거 하는 유틸 Hook ( [Web발신] 문장 제거 후 라인 제거 )
 *
 * @author 정휘학
 * @since 2024.04.16
 * */
export const removeWebCharacter = (str: string, charToRemove: string) => {
  // 정규 표현식을 사용하여 지정한 문자를 전역적으로 찾아 제거합니다.
  // const regex = new RegExp(charToRemove, 'g');
  if (str) {
    const splitMsg = str.split(charToRemove);
    const filterMessages = splitMsg.filter((msg) => msg !== '');
    return filterMessages.join().replace('\n', '');
  }
  return '';
};
